export default __webpack_public_path__ + "static/media/g.792b9c9a.png";